module.exports = __webpack_public_path__ + "static/media/vf_wdressshoes_core.0638629a.svg";